import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./SignUp.module.css";
import { singInRequest } from "../../api/index";
import { useIntl } from "react-intl";
export const SignUp = () => {
  const navigate = useNavigate();
  const intl = useIntl();

  const [formData, setFormData] = useState({
    // firstName: "",
    // lastName: "",
    email: "",
    name: "",
    password: "",
    // confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  let usetData = {
    email: formData.email,
    name: formData.name,
    password: formData.password,
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = await singInRequest(usetData);

    if (data) {
      navigate("/thank-you");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.header}>
          <Link to="/" className={styles.logo}>
            viewStruct
          </Link>
          <h1 className={styles.title}>
            {intl.formatMessage({ id: "signUpId1" })}
          </h1>
          <p className={styles.subtitle}>
            {intl.formatMessage({ id: "signUpId2" })}
          </p>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.nameRow}></div>

          <div className={styles.inputGroup}>
            <label htmlFor="email" className={styles.label}>
              {intl.formatMessage({ id: "signUpId3" })}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              placeholder={intl.formatMessage({ id: "signUpId4" })}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="company" className={styles.label}>
              {intl.formatMessage({ id: "signUpId5" })}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={styles.input}
              placeholder={intl.formatMessage({ id: "signUpId6" })}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              {intl.formatMessage({ id: "signUpId7" })}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={styles.input}
              placeholder={intl.formatMessage({ id: "signUpId8" })}
              required
            />
          </div>

          <button type="submit" className={styles.submitBtn}>
            {intl.formatMessage({ id: "signUpId9" })}
          </button>
        </form>

        <div className={styles.divider}>
          <span>or</span>
        </div>

        <div className={styles.socialButtons}>
          <button className={styles.socialBtn}>
            <span>Continue with Google</span>
          </button>
          <button className={styles.socialBtn}>
            <span>Continue with Microsoft</span>
          </button>
        </div>

        <p className={styles.signinPrompt}>
          {intl.formatMessage({ id: "signUpId10" })}
          <Link to="/signin" className={styles.signinLink}>
            {intl.formatMessage({ id: "signUpId11" })}
          </Link>
        </p>
      </div>

      <div className={styles.backgroundDecoration}>
        <div className={styles.shape1}></div>
        <div className={styles.shape2}></div>
        <div className={styles.shape3}></div>
      </div>
    </div>
  );
};
